import {DropdownActionMenuItem} from 'platform/components';

import {defaultTo, pipe, reject, sortBy, prop} from 'ramda';
import {mapIndexed} from 'ramda-adjunct';

import i18n from '@dms/i18n';

import {Nullish} from 'shared/web';

import {ServiceActionOptionType} from '../types/serviceActionOptionType';

const isDivider = (option: DropdownActionMenuItem) => option.label === 'divider';
const isHidden = (option: ServiceActionOptionType) => option?.style === 'hidden';
const transformToDropdown =
  (
    onClick: (key: 'cancel' | 'reOpen' | Nullish) => void,
    isAnyActionPending: boolean,
    canCancel: boolean
  ) =>
  (option: ServiceActionOptionType, index: number, list: ServiceActionOptionType[]) => {
    const isCancelDenied = option?.key === 'cancel' && !canCancel;

    return {
      label: option?.key ? i18n.t(`entity.service.actions.${option?.key}`) : (option?.type ?? ''),
      isDisabled: option?.style === 'disabled' || isAnyActionPending || isCancelDenied,
      tooltip: isCancelDenied ? {label: i18n.t('general.labels.noPermission')} : undefined,
      onClick: () => onClick(option?.key),
      hasSeparator: list[index + 1]?.type === 'divider',
    };
  };

export const getMenuItemsFromActions = (
  onClick: (key: 'cancel' | 'reOpen' | Nullish) => void,
  isAnyActionPending: boolean,
  canCancel: boolean
) =>
  pipe<
    [ServiceActionOptionType[] | Nullish],
    ServiceActionOptionType[],
    ServiceActionOptionType[],
    ServiceActionOptionType[],
    DropdownActionMenuItem[],
    DropdownActionMenuItem[]
  >(
    defaultTo([]),
    reject(isHidden),
    sortBy(prop('position')),
    mapIndexed(transformToDropdown(onClick, isAnyActionPending, canCancel)),
    reject(isDivider)
  );
